import React, { useState } from 'react';
import { FileText, Check, Loader2 } from 'lucide-react';
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from './firebase';

const TermsModal = ({ user, onAccepted }) => {
  const [isAccepted, setIsAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAccept = async () => {
    if (!isAccepted) return;
    
    setIsSubmitting(true);
    try {
      // Aggiorna il documento utente nel DB
      const userRef = doc(db, 'users', user.uid);
      await updateDoc(userRef, {
        termsAccepted: true,
        termsAcceptedAt: serverTimestamp(),
        privacyPolicyVersion: '1.0',
        termsVersion: '1.0'
      });
      
      // Notifica al componente padre che è stato accettato
      if (onAccepted) onAccepted();
      
    } catch (error) {
      console.error("Errore accettazione termini:", error);
      alert("Si è verificato un errore. Riprova.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.9)' }}>
      <div className="modal-content" style={{ maxWidth: '600px' }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ 
            width: '60px', height: '60px', background: '#e3f2fd', 
            borderRadius: '50%', display: 'flex', alignItems: 'center', 
            justifyContent: 'center', margin: '0 auto 1rem' 
          }}>
            <FileText size={30} color="#1565c0" />
          </div>
          <h2>Benvenuto in ITAD.hub</h2>
          <p style={{ color: '#666' }}>
            Prima di continuare, è necessario leggere e accettare i nostri termini di servizio e la privacy policy.
          </p>
        </div>

        <div style={{ 
          background: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', 
          border: '1px solid #eee', marginBottom: '1.5rem', maxHeight: '200px', 
          overflowY: 'auto' 
        }}>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.8' }}>
            <li>
              <a href="/termini-condizioni.html" target="_blank" style={{ color: '#1565c0', fontWeight: 600 }}>
                Termini e Condizioni di Servizio
              </a>
            </li>
            <li>
              <a href="/privacy-policy.html" target="_blank" style={{ color: '#1565c0', fontWeight: 600 }}>
                Privacy Policy
              </a>
            </li>
          </ul>
          <p style={{ fontSize: '0.85rem', color: '#888', marginTop: '10px' }}>
            Cliccando sui link sopra, i documenti si apriranno in una nuova scheda.
          </p>
        </div>

        <label style={{ 
          display: 'flex', alignItems: 'flex-start', gap: '10px', 
          cursor: 'pointer', padding: '10px', borderRadius: '8px',
          background: isAccepted ? '#e8f5e9' : 'transparent',
          transition: 'background 0.2s'
        }}>
          <input 
            type="checkbox" 
            checked={isAccepted} 
            onChange={(e) => setIsAccepted(e.target.checked)}
            style={{ marginTop: '4px', width: '18px', height: '18px', cursor: 'pointer' }}
          />
          <span style={{ fontSize: '0.9rem', lineHeight: '1.4' }}>
            Dichiaro di aver letto e compreso i <strong>Termini e Condizioni</strong> e la <strong>Privacy Policy</strong>, 
            e accetto integralmente il loro contenuto.
          </span>
        </label>

        <button 
          className="btn-primary" 
          onClick={handleAccept}
          disabled={!isAccepted || isSubmitting}
          style={{ 
            width: '100%', justifyContent: 'center', marginTop: '1.5rem',
            opacity: (!isAccepted || isSubmitting) ? 0.5 : 1
          }}
        >
          {isSubmitting ? <Loader2 className="animate-spin" /> : (
            <>
              <Check size={20} /> Accetto e Continua
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default TermsModal;